import { render, staticRenderFns } from "./TourTabsNotes.vue?vue&type=template&id=3c0426ed&scoped=true&"
import script from "./TourTabsNotes.vue?vue&type=script&lang=js&"
export * from "./TourTabsNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0426ed",
  null
  
)

export default component.exports